<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <!-- 广告图 -->
            <div class="ad">
                <div class="topImg bg-contain"></div>
            </div>
            <div class="wrapper">
                <validation-observer v-slot="{ invalid }" ref="form">
                    <!-- 租车订单 -->
                    <div class="order r16 bh bbetween" @click="go('ScooterOrderList')">
                        <div class="fz_30">
                            <span class="orderText r6 fz_24 c_white">订单</span>租车订单
                        </div>
                        <validation-provider
                            :customMessages="{required:'正在租车中...'}"
                            :rules="{required: { allowFalse: false } }"
                        >
                            <input type="hidden" v-model="isRenting" />
                        </validation-provider>
                        <div class="right bh bc">
                            <div class="rentIng fz_28" v-show="!isRenting">租车中</div>
                            <div class="ico-compNext nextIco bg-contain"></div>
                        </div>
                    </div>
                    <!-- 代步车预定 -->
                    <validation-provider
                        :customMessages="{required:'您还没有开启代步券权益'}"
                        :rules="{required: { allowFalse: false } }"
                    >
                        <input type="hidden" v-model="vipFlag" />
                    </validation-provider>
                    <div class="reserve bh bc" @click="isShow">
                        <div class="reserveText fz_34">出险代步车预定</div>
                        <div
                            class="vipNoIco bg-contain"
                            :class="vipFlag ? 'ico-vipYes':'ico-vipNo'"
                        ></div>
                    </div>
                    <!-- 取还车车模块 -->
                    <div class="car">
                        <!-- 取还车城市模块 -->
                        <div class="get">
                            <div class="title bh bstart">
                                <div class="titleCity b2 fz_28 c_666">取车城市</div>
                                <div class="titleComp b8 fz_28 c_666">取车地点</div>
                            </div>
                            <div class="content bh bstart">
                                <div class="contentCity b2 fz_34">内蒙</div>
                                <div class="contentComp company b8" >
                                    <van-action-sheet
                                        v-model="show"
                                        :actions="addressList"
                                        @select="onSelect"
                                        :round="false"
                                        :closeOnClickAction="true"
                                    />
                                    <div class="bh bbetween" @click="show=true">
                                        <validation-provider name="取还车公司" rules="required">
                                            <van-field
                                                readonly
                                                v-model="companyName"
                                                placeholder="请选择取车地点"
                                            />
                                        </validation-provider>
                                        <div
                                            class="ico-compDown downIco bg-contain"
                                        ></div>
                                    </div>
                                    <div class="fz_28 c_666 address">{{ address }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="return">
                            <div class="title bh bstart">
                                <div class="titleCity b2 fz_28 c_666">还车城市</div>
                                <div class="titleComp b8 fz_28 c_666">还车地点</div>
                            </div>
                            <div class="content bh bstart">
                                <div class="contentCity b2 fz_34">内蒙</div>
                                <div class="b8">
                                    <div class="fz_34 contentComp">{{ companyName }}</div>
                                    <div class="contentComp addr address c_666 fz_28">{{ address }}</div>
                                </div>
                            </div>
                        </div>
                        <!-- 取还车时间模块 -->
                        <validation-provider
                            name="取还车时间"
                            :rules="{required: { allowFalse: false } }"
                        >
                            <input type="hidden" v-model="okFlag" />
                        </validation-provider>
                        <div class="time bh">
                            <div class="getTime" @click="isGetOrRtn('get')">
                                <div class="title fz_24 c_999">取车时间</div>
                                <div class="date fz_34">{{showGetCarTime[0] || "- -"}}</div>
                                <div
                                    class="week fz_24 c_999"
                                >{{getWeek || "- -"}} {{showGetCarTime[1] || "- -"}}</div>
                            </div>
                            <div class="allTime bh bc b1">
                                <div class="leftLine"></div>
                                <div class="timeText fz_28 c_999">共{{showCutTime || "- -"}}</div>
                                <div class="rightLine ico-line bg-contain"></div>
                            </div>
                            <div class="rtnTime" @click="isGetOrRtn('rtn')">
                                <div class="title fz_24 c_999 tr">还车时间</div>
                                <div class="date fz_34 tr">{{showRtnCarTime[0] || "- -"}}</div>
                                <div
                                    class="week fz_24 c_999 tr"
                                >{{rtnWeek || "- -"}} {{showRtnCarTime[1] || "- -"}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 规则 -->
                    <div class="rule bh bc">
                        <validation-provider
                            :rules="{required: { allowFalse: false } }"
                            :customMessages="{required:'请阅读并勾选代步车规则'}"
                        >
                            <van-checkbox
                                v-model="radio"
                                checked-color="#c30d23"
                                icon-size="16px"
                                shape="square"
                            >
                                <div class="fz_28">
                                    已阅读并同意
                                    <span
                                        class="ruleText"
                                        @click="showDialog('isDialog')"
                                    >《代步车规则》</span>
                                    <span class="fz_24 c_666">(请填写真实信息)</span>
                                </div>
                            </van-checkbox>
                        </validation-provider>
                    </div>
                    <!-- 租车按钮 -->
                    <div class="rentBtn bh bc">
                        <van-button
                            size="large"
                            class="logBtn btn btn-submit-big"
                            :class="getBtnCls(invalid)"
                            @click="onBuyClick"
                        >立即租车</van-button>
                    </div>
                </validation-observer>
                <!-- 权限弹窗 -->
                <van-overlay
                    class="dialog bv bc"
                    :show="isReserveDialog"
                    @click="hiddenDialog('isReserveDialog')"
                >
                    <div class="ruleDialog-container">
                        <div class="ruleDialog-wrap r10" @click.stop>
                            <div class="fz_34 tc">出险代步车预定</div>
                            <div
                                class="tl fz_28"
                            >{{`您当前暂时无法享受代步车服务，若需享受该服务请联系${$store.state.tell}`}}</div>
                            <div class="bh bc btn-container">
                                <van-button
                                    size="large"
                                    class="logBtn btn btn-submit-big"
                                    @click="hiddenDialog('isReserveDialog')"
                                >
                                    <div class="fz_28">知道啦</div>
                                </van-button>
                            </div>
                        </div>
                    </div>
                </van-overlay>
                <!-- 取还车时间弹窗 -->
                <van-popup
                    v-model="isTimeDialog"
                    position="bottom"
                    @close="getOrRtn=''"
                    :style="{ height: '50%' }"
                >
                    <div class="bh timeDialog-container">
                        <div class="dialog-wrap r10" @click.stop>
                            <timePicker v-model="timeInfo" :getOrRtn="getOrRtn"></timePicker>
                        </div>
                    </div>
                </van-popup>
            </div>
        </div>
        <van-overlay class="dialog" :show="isDialog" @click="hiddenDialog('isDialog')">
            <div class="bh bc dialog-container">
                <div class="dialog-wrap r10" @click.stop>
                    <div class="fz_34 rools">代步车规则</div>
                    <div class="tl textIndent-wrap">
                        <div class="textIndent">1.取车时必须携带本人有效期内的身份证、驾驶证及信用卡，严禁他人代取、代付；</div>
                        <div class="textIndent">2.取车押金为: 2000元信用卡预授权，暂不支持消费、现金及网络支付押金方式；</div>
                        <div class="textIndent">3.免费期内不收车辆使用费，超过免费期后将收取超期使用费或超时费；</div>
                        <div class="textIndent">4.免费期后续期需提前4小时与八保舟联系，同意后方可续期，强行续期将收取300%违约金；</div>
                        <div class="textIndent">5.免费期内提前还车不予以补偿；</div>
                        <div class="textIndent">6.修改订单需提前2小时与工作人员联系，工作人员确认可以修改后方可修改；</div>
                        <div class="textIndent">7.取/还车业务需在营业时间内办理，营业时间:09:00---18:00；</div>
                        <div class="textIndent">8.租车中的用户不能再次提交租车订单。</div>
                    </div>
                    <div class="bh bc btn-container">
                        <van-button class="btn btn-goodbuy" @click="hiddenDialog('isDialog')">
                            <div class="fz_28">知道啦</div>
                        </van-button>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import moment from "moment";
import timePicker from "@/components/picker/TimePicker";
import { mixinDialog } from "@/mixin/dialog";
import { user } from "@/mixin/user";
import { mixinValid } from "@/mixin/valid";
import { routeCache } from "@/mixin/cache";

export default {
    components: { timePicker },
    mixins: [mixinDialog, user, mixinValid, routeCache],
    name: "ScooterHome",
    data() {
        return {
            checked: false,
            // 是否显示选择公司模块
            show: false,
            // 是否弹出预定权限提示框
            isReserveDialog: false,
            // 是否弹出取还车时间选择
            isTimeDialog: false,
            // 公司名
            companyName: "",
            // 地址
            address: "",
            // 门店id
            id: "",
            // 子组件传出来的取还车时间信息
            timeInfo: "",
            timeData: {},
            // 取车时间 用于计算
            getCarTime: "",
            // 取车时间 用于显示
            showGetCarTime: "",
            // 还车时间 用于计算
            rtnCarTime: "",
            // 还车时间 用于显示
            showRtnCarTime: "",
            // 取车星期
            getWeek: "",
            // 还车星期
            rtnWeek: "",
            // 租车时长
            showCutTime: "3天0小时",
            // 星期数组
            weekArr: [
                "星期日",
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六"
            ],
            // 是否vip
            vipFlag: false,
            // 是否租车中
            isRenting: true,
            // 代步车规则
            radio: false,
            // 判断用户点击的是取车时间还是还车时间
            getOrRtn: ""
        };
    },
    mounted() {
        let curDate, nowTime;
        const now = new Date(),
            nowMinu = moment().minutes(),
            nowHours = moment().hours();
        if (nowHours < 9) {
            nowTime = "09:00";
            curDate = now;
        } else if (nowHours >= 18) {
            nowTime = "09:00";
            curDate = moment(now).add(1, "day");
        } else {
            if (nowMinu < 30) {
                if (nowHours == 9) {
                    nowTime = `0${nowHours}:30`;
                } else {
                    nowTime = `${nowHours}:30`;
                }
            } else {
                nowTime = `${nowHours + 1}:00`;
            }
            curDate = now;
        }
        console.log(curDate);
        this.getCarTime = `${moment(curDate).format("YYYY-MM-DD")} ${nowTime}`;
        this.rtnCarTime = `${moment(curDate)
            .add(3, "day")
            .format("YYYY-MM-DD")} ${nowTime}`;
        console.log(this.getCarTime, this.rtnCarTime);
        this.showGetCarTime = [moment(curDate).format("MM月DD日"), nowTime];
        this.showRtnCarTime = [
            moment(curDate)
                .add(3, "day")
                .format("MM月DD日"),
            nowTime
        ];
        this.getWeek = this.weekArr[moment(curDate).weekday()];
        this.rtnWeek = this.weekArr[
            moment(curDate)
                .add(3, "day")
                .weekday()
        ];
    },
    activated() {
        this.$store.dispatch("scooter/scooterVip");
    },
    methods: {
        // 获取数据后执行
        userLoginend() {
            this.$store.dispatch("scooter/addressList");
            this.$store.dispatch("scooter/scooterVip");
        },
        isShow() {
            if (!this.vipFlag) {
                this.showDialog("isReserveDialog");
            }
        },
        // 选择公司后执行，带出详细地址
        onSelect(v1, v2) {
            console.log(v1, v2);
            this.companyName = v1.name;
            this.address = v1.subname;
            this.id = v1.id;
        },
        // 提交按钮
        onBuyClick() {
            this.validForm().then(() => {
                // 判断权限
                if (!this.vipFlag) {
                    this.showDialog("isReserveDialog");
                } else {
                    this.$router.push({
                        name: "ScooterOrderConfirm",
                        params: {
                            orderType: "0",
                            isCart: false,
                            confirmList: {
                                // getCarInfo: {
                                    getCarTime: this.getCarTime, // 取车时间  用于计算转换
                                    getWeek: this.getWeek, // 取车星期
                                // },T
                                // rtnCarInfo: {
                                    rtnCarTime: this.rtnCarTime, // 还车时间  用于计算转换
                                    rtnWeek: this.rtnWeek, // 还车星期
                                // },
                                allTime: this.showCutTime, // 租车时长
                                address: this.address, // 取还地址
                                companyName: this.companyName, // 取还公司
                                id: this.id // 门店id
                            }
                        }
                    });
                }
            });
        },
        // 判断用户点击的是取车时间还是还车时间，
        isGetOrRtn(v) {
            this.isTimeDialog = true;
            this.getOrRtn = v;
        }
    },
    computed: {
        // 取还车时间是否完整
        okFlag() {
            return this.timeData.rtnCarTime || this.rtnCarTime[0];
        },
        // 门店地址
        addressList() {
            const res = this.$store.getters["scooter/addressList"];
            console.log(res);
            const info = [];
            for (let i = 0; i < res.length; i++) {
                info.push({
                    name: res[i].store[0].storeName,
                    subname: res[i].store[0].address,
                    id: res[i].store[0].id
                });
            }
            return info;
        },
        // 用户权限
        userVip() {
            return this.$store.getters["scooter/scooterVip"];
        }
    },
    watch: {
        // 用户权限
        userVip() {
            console.log(this.userVip);
            this.vipFlag = this.userVip.open;
            this.isRenting = !this.userVip.using;
            if (!this.vipFlag) {
                this.showDialog("isReserveDialog");
            }
        },
        // 监听子组件传过来的数据，如果点击确定，更新时间数据
        timeInfo() {
            if (!this.timeInfo.isChange) {
                // 如果点击取消，关闭弹窗，数据不做处理
                this.isTimeDialog = false;
            } else {
                console.log(this.timeInfo);
                this.timeData = this.timeInfo;
                this.getCarTime = this.timeInfo.getCarTime;
                this.rtnCarTime = this.timeInfo.rtnCarTime;
                this.showGetCarTime = moment(this.timeInfo.getCarTime)
                    .format("MM月DD日 HH:mm")
                    .split(" ");
                this.showRtnCarTime = this.timeInfo.rtnCarTime
                    ? moment(this.timeInfo.rtnCarTime)
                          .format("MM月DD日 HH:mm")
                          .split(" ")
                    : ["", ""];
                this.showCutTime = this.timeInfo.showCutTime;

                this.getWeek = this.weekArr[
                    moment(this.timeInfo.getCarTime).weekday()
                ];
                this.rtnWeek = this.timeInfo.rtnCarTime
                    ? this.weekArr[moment(this.timeInfo.rtnCarTime).weekday()]
                    : "";
                this.isTimeDialog = false;
            }
        }
    }
};
</script>
<style scoped lang="scss">
.scrollbar-container {
    background-color: #f6f6f6;
    .topImg {
        height: 320px;
        background-image: url("~@/assets/imges/scooter/topAd.png");
    }
    .wrapper {
        padding: 0 30px;
        .order {
            margin: 24px 0;
            padding: 20px;
            background-color: white;
            .orderText {
                padding: 4px 8px;
                margin-right: 19px;
                background-color: #ef7170;
            }
            .rentIng {
                color: #c30d23;
                padding-right: 20px;
            }
            .nextIco {
                height: 30px;
                width: 16px;
            }
        }
        .reserve {
            position: relative;
            padding: 18px;
            border-radius: 16px 16px 0 0;
            background-color: #e5e5e5;
            .vipNoIco {
                position: absolute;
                top: 0;
                left: -3px;
                width: 138px;
                height: 60px;
            }
        }
        .car {
            padding: 50px 30px;
            background-color: #fff;
            .get {
                padding-bottom: 40px;
                .downIco {
                    width: 30px;
                    height: 16px;
                }
            }
            .titleComp {
                margin-left: 40px;
            }
            .contentComp {
                margin-left: 40px;
            }
            .content {
                padding: 20px 0 30px 0;
                border-bottom: 1px solid #dcdcdc;
                height: 70px;
                .addr {
                    min-height: 45px;
                }
            }
            .address{
                width: 450px;
                white-space:nowrap;
                text-overflow:ellipsis;
                overflow:hidden;
            }
            .company {
                .van-cell {
                    padding: 0;
                }
                .van-action-sheet {
                    max-height: 55%;
                    border-radius: 16px 16px 0 0;
                    .van-action-sheet__item {
                        height: 150px;
                        padding: 25px 0 0 0;
                    }
                    .van-action-sheet__name {
                        padding: 10px 0;
                    }
                }
                /deep/ .van-field__control {
                    font-size: 34px;
                    // line-height: 1.6;
                }
            }
            .time {
                padding-top: 40px;
                .date {
                    padding: 10px 0;
                }
                .allTime {
                    .leftLine {
                        width: 60px;
                        height: 1px;
                        border-bottom: 1px solid #dcdcdc;
                    }
                    .timeText {
                        padding: 0 17px;
                    }
                    .rightLine {
                        width: 60px;
                        height: 10px;
                    }
                }
            }
        }
        .rule {
            padding-top: 30px;
            line-height: 30px;
            /deep/ .van-icon {
                border-radius: 4px;
                background-color: #b9b9b9;
            }
            .ruleText {
                padding: 0 8px 0 0;
                color: #c30d23;
            }
        }
        .rentBtn {
            padding: 90px 30px;
        }
        .van-popup {
            border-radius: 16px 16px 0 0;
        }
        .timeDialog-container {
            width: 100%;
            .dialog-wrap {
                width: 100%;
            }
        }
        .ruleDialog-container {
            width: 80%;
            .ruleDialog-wrap {
                padding: 30px 20px;
                background-color: #fff;
                .btn-container {
                    padding: 30px 100px 0px;
                }
            }
        }

        .van-action-sheet__item {
            display: flex;
            flex-direction: column;
            line-height: inherit;
            align-items: center;
        }
    }
}
.dialog {
    .dialog-container {
        height: 100%;
        padding: 0 55px;
    }
    .dialog-wrap {
        position: relative;
        background: #fff;
        padding: 60px 55px;
    }
    .rools {
        padding-bottom: 30px;
    }
    .textIndent-wrap {
        padding-left: 30px;
        .textIndent {
            text-indent: -28px;
        }
    }
    .btn-goodbuy {
        width: 300px;
    }
}
</style>